export const getIconInfoById = (id) => {
  if (!id) return { category: "utility", name: "salesforce1", title: "Unknown Record" }; //question

  const prefix = id.substring(0, 3);

  const prefixToIcon = {
    "003": { category: "standard", name: "contact", title: "Contact" },
    "00Q": { category: "standard", name: "lead", title: "Lead" },
    "001": { category: "standard", name: "account", title: "Account" },
    "006": { category: "standard", name: "opportunity", title: "Opportunity" },
    500: { category: "standard", name: "case", title: "Case" },
    701: { category: "standard", name: "campaign", title: "Campaign" },
    "00T": { category: "standard", name: "task", title: "Task" },
    "00U": { category: "standard", name: "event", title: "Event" },
    "00v": { category: "standard", name: "campaign_members", title: "Campaign Member" },
    800: { category: "standard", name: "contract", title: "Contract" },
    "02i": { category: "standard", name: "asset_object", title: "Asset" },
    "01t": { category: "standard", name: "product", title: "Product" },
    "005": { category: "standard", name: "user", title: "User" },
  };

  return (
    prefixToIcon[prefix] || { category: "utility", name: "salesforce1", title: "Unknown Record" }
  ); //question
};
